<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader tipo="table-heading, card" ruta="niveles" />
    </v-container>
    <v-container v-else class="custom-content-padding">
        <v-card class="rounded-0" flat>
            <v-card-title class="font-weight-bold text-h5">
                <RoundDiversity3 color="primary" />
                <v-icon class="mr-3" size="34" color="primary">mdi-account-round</v-icon>
                Subsidios
            </v-card-title>
            <v-row class="d-flex">
                <v-col cols="12" md="4" class="d-flex justify-center">
                    <v-card class="d-flex" v-model="selectedBtn" flat :class="cardClass">
                        <v-card-title v-if="$vuetify.breakpoint.mdAndUp"
                            class="d-flex flex-row justify-center align-center font-weight-bold primary--text text-h6"
                            style="word-break: keep-all;" width="450px">
                            Solicitud de subsidios
                        </v-card-title>
                        <v-slide-group v-if="$vuetify.breakpoint.smAndDown" center-active show-arrows>
                            <v-slide-item v-for="button in subsidiosDisponibles" :key="button.value" :value="button.value"
                                class="align-center justify-center">
                                <v-btn elevation="0" class="white--text font-weight-bold justify-center"
                                    :outlined="selectedBtn !== button.value" color="primary"
                                    style="word-break: keep-all; border: 2px solid;" :class="buttonClass"
                                    @click="selectButton(button.value)">
                                    {{ button.title }}
                                </v-btn>
                            </v-slide-item>
                        </v-slide-group>
                        <template v-else>
                            <v-btn v-for="button in subsidiosDisponibles" :key="button.value"
                                :outlined="selectedBtn !== button.value" elevation="0"
                                style="border: 2px solid; white-space: normal; font-size: 12px;"
                                class="mb-4 py-5 white--text font-weight-bold justify-center text-wrap" color="primary"
                                @click="selectButton(button.value)">
                                {{ button.title }}
                            </v-btn>
                        </template>
                    </v-card>
                </v-col>
                <v-col cols=" 12" md="8">
                    <v-card flat>
                        <v-card-text class="font-weight-regular text-h6 primary--text" style="line-height: 1.2;">
                            <b>{{ selectedButton.title.toUpperCase() }}</b> {{ selectedButton.subtitle }}
                        </v-card-text>
                        <v-card-text v-if="!selectedButton.title.toUpperCase().includes('MATERNIDAD')"
                            class="font-weight-bold text-body-2">
                            <v-card color="secondary" dark class="d-inline align-center justify-center pa-3 rounded-0"
                                flat>
                                {{ modulos }} MÓDULOS
                            </v-card>
                        </v-card-text>
                        <v-card-text class="text-body-1 black--text">
                            <div v-for="(paragraph, index) in splitParagraph(selectedButton.parrafo)" :key="index">
                                {{ paragraph }}
                            </div>
                        </v-card-text>
                        <v-card-text class="d-flex flex-column align-end justify-end ma-0 pa-0">
                            <v-btn text color="primary" @click="goToWeb(selectedButton.url)" class="pa-5 elevation-0">
                                <v-icon class="mr-2">mdi-information-outline</v-icon>Más información en la web
                            </v-btn>
                        </v-card-text>
                        <template v-if="selectedButton.title.toUpperCase().includes('MATERNIDAD')">
                            <v-card-text class="d-flex flex-column align-center">
                                <v-card v-for="(items, index) in nivelAporte" :key="index" flat class="mb-1">
                                    <div class="d-flex flex-row justify-center">
                                        <v-card color="secondary" dark
                                            class="d-flex font-weight-bold rounded-0 align-center py-1 px-5" flat>
                                            NIVEL {{ index + 1 }}
                                        </v-card>
                                        <v-card flat
                                            class="font-weight-bold align-center justify-center rounded-0 py-1 px-2"
                                            style="border: 2px solid #092E6F;">
                                            {{ items.cant }} MÓDULOS
                                        </v-card>
                                    </div>
                                </v-card>
                            </v-card-text>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
        <v-card-actions class="py-2 px-0 rounded-0 custom-card-actions-ha" :style="{
            left: $vuetify.application.left + 'px', height: 'auto'
        }">
            <v-row class="ma-0 pa-0">
                <v-col cols="12" md="12" :class="$vuetify.breakpoint.mdAndUp ? 'd-flex justify-end py-2' : 'py-2'">
                    <v-btn @click="subsidioSelected(selectedButton.route)" elevation="0" color="primary"
                        class="pa-5 font-weight-bold text-caption" :block="!$vuetify.breakpoint.mdAndUp">
                        <v-icon class="mr-1">mdi-chevron-right</v-icon>
                        SELECCIONAR {{ selectedButton.title }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-container>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import RoundDiversity3 from '@/assets/icons/round-diversity-3.vue'
import SubsidiosCard from '@/components/cards/SubsidiosCard.vue'
import CarouselCard from '@/components/cards/CarouselCard.vue'
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'

export default {
    components: {
        RoundDiversity3,
        SubsidiosCard,
        SkeletonLoader,
        CarouselCard,
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'loadSkeleton', 'user']),
        ...mapGetters('subsidios', ['validAportesPagos', 'validPlanPagos', 'subsidiosDisponibles']),

        selectedButton() {
            const items = this.subsidiosDisponibles;
            if (!items.length) return {};
            return items.find(button => button.value === this.selectedBtn) || items[0];
        },
        cardClass() {
            return this.$vuetify.breakpoint.smAndDown ? 'flex-row' : 'flex-column';
        },
        buttonClass() {
            return this.$vuetify.breakpoint.smAndDown ? 'ml-1 py-5' : 'py-5 mb-5';
        },
    },
    watch: {
        // Mantiene selectedBtn dentro de los disponibles. Cubre el caso en
        // que el user se hidrate despues del created (auth async) y el set
        // filtrado por sexo cambie.
        subsidiosDisponibles: {
            immediate: true,
            handler(items) {
                if (!items.length) return;
                const sigueValido = items.some(b => b.value === this.selectedBtn);
                if (!sigueValido) this.selectedBtn = items[0].value;
            },
        },
    },
    methods: {
        goToWeb(url) {
            window.open(url, '_blank')
        },
        selectButton(value) {
            this.selectedBtn = value;
        },
        splitParagraph(paragraph) {
            return paragraph.split('. ').map(p => p.trim() + '.');
        },
        subsidioSelected(route) {
            this.$router.push(route);
        }
    },
    data() {
        return {
            selectedBtn: null,
            modulos: 180,

            nivelAporte: [
                { nivel: 1, cant: 110 },
                { nivel: 2, cant: 180 },
                { nivel: 3, cant: 250 },
                { nivel: 4, cant: 350 },
                { nivel: 5, cant: 550 },
            ],
        }
    }
}
</script>

<style>
.espacio-letras {
    letter-spacing: .05rem;
}

.subtitulo {
    /*     font-family: system-ui; */
    font: caption;
    font-size: 1.2rem;
    padding: 3px 0 6px 0;
}

.text-wrap {
    white-space: normal;
    word-wrap: break-word;
}

/* Footer fijo con el boton "SELECCIONAR" — mismo patron que PlanesDePago.vue.
   El padding-bottom del container outer reserva espacio para que el contenido
   no quede tapado por el footer. */
.custom-card-actions-ha {
    position: fixed;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    left: 0;
}

.custom-content-padding {
    padding-bottom: 80px;
}
</style>